import React from "react";
import {TableCell, TableRow} from "@mui/material";
import StringHelper from "../../../../helpers/StringHelper";
import { defaultProps } from "recompose";
const NumSSBloc = ({numSS, ...props}) => (
    <React.Fragment>
        {
            numSS && <TableRow item { ...props}>
                <TableCell variant="head">Numéro de sécurité sociale</TableCell>
                <TableCell> : </TableCell>
                <TableCell>{StringHelper.formatSSNum(numSS)}</TableCell>
            </TableRow>
        }
    </React.Fragment>
)

NumSSBloc.withDefaultProps = defaultProps({
    numSS: "",
    sm: 6,
    xs: 6,
    id: ""
})

export default NumSSBloc;
